import React from 'react';

export default () => (
  <svg width='45' height='45' viewBox='0 0 45 45' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect x='17' y='15' width='3.75' height='15' rx='1.875' fill='#4F4F4F' />
    <rect x='24.6877' y='15' width='3.75' height='15' rx='1.875' fill='#4F4F4F' />
  </svg>
);
